Z<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container(v-if="id !== null")
        h1 ご注文が完了しました

        v-layout.container.justify-center(row wrap)
          v-layout.text-xs-center.my-5.stepper(row wrap)
            v-flex(xs12)
              p.my-3 ご注文の流れ
              ul.list-unstyled.multi-steps
                li
                  | ご注文内容の確認
                  br
                  | お客様情報・配送指定
                li ご入力内容の確認
                li.is-active 注文完了

        v-layout.pa-3.mt-3.white_container.justify-center(row wrap)
          v-flex(xs12)
            h2
             | ありがとうございました
             br
             | ご注文が確定されました
          v-flex.num.my-5(xs12)
            p.text-xs-center ご注文番号
            span.primary--text.text-xs-center {{id}}
          v-layout(row wrap).text-xs-left.text-md-center
            v-flex.message(xs12)
              span
                | ご入力いただいたメールアドレス宛に、注文受付のメールを送信いたしました。
                br
                | もししばらく経ってもメールが届かない場合は
                router-link(to="/contact") 「お問い合わせフォーム」
                | よりご連絡ください。
                br
                | この度はビュルガーをご購入いただき、誠にありがとうございました。
                br
                | ご意見等ございましたら、お気軽にお寄せくださいませ。
            v-flex.mt-5(xs12)
              router-link(to="/top" tag="li")
                v-btn(color="primary" round outline) TOPページ
    CommonFooter
</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted () {
    this.$vuetify.theme.error = '#9e5d0d'
    this.$vuetify.theme.accent = '#9e5d0d'
  },
  data () {
    return {
      id: null
    }
  },
  created () {
    if (!this.$route.params.id) {
      this.$router.push('/')
    }
    this.id = this.$route.params.id
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc
.section
  border-top 1px solid $color-primary
  padding 2rem 0
.num
  font-weight bold
  p
    height 40px
    background-color $shop-secondary
    border-top-right-radius 20px
    border-top-left-radius 20px
    padding 10px 0
  span
    height 60px
    font-size 2rem
    border-bottom-right-radius 20px
    border-bottom-left-radius 20px
    border 2px solid $shop-secondary
    display block
    padding 3px 0
.message
  span
    font-size 0.9rem
  a
    color $shop-secondary
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/CartDanke/index.vue